module.exports = __webpack_public_path__ + "img/help.a3d5f2fa.svg";